import React from "react";
import { Box, Container, Heading, Icon, Text } from "@chakra-ui/react";
import { FaHeadset } from "react-icons/fa";
import HelpDeskContent from "../components/HelpDeskContent";

/**
 * Standalone Help Desk page at /help-desk. Public route — works whether
 * the visitor is signed in or not. Same body as the modal triggered by
 * HelpDeskButton, just framed as a full page so the URL can be shared.
 */
const HelpDeskPage = () => {
  return (
    <Box
      minH="100vh"
      w="100%"
      bg="gray.50"
      display="flex"
      flexDirection="column"
    >
      <Container
        maxW={{ base: "100%", md: "3xl", lg: "4xl" }}
        px={{ base: 3, md: 6 }}
        py={{ base: 3, md: 5 }}
        flex="1"
        display="flex"
        flexDirection="column"
      >
        <Box mb={{ base: 3, md: 4 }} flexShrink={0}>
          <Heading size={{ base: "md", md: "lg" }} mb={1}>
            <Icon as={FaHeadset} mr={2} color="red.500" verticalAlign="middle" />
            Help Desk
          </Heading>
          <Text color="gray.600" fontSize={{ base: "sm", md: "md" }}>
            Send us a message, report a bug, or book a 30-minute meeting with the
            team. Times shown are Eastern Time.
          </Text>
        </Box>
        <Box flex="1" overflow="auto">
          <HelpDeskContent />
        </Box>
      </Container>
    </Box>
  );
};

export default HelpDeskPage;
